class AdminRolesDatatable {
    constructor(){
        let organizationID = new URLSearchParams(window.location.search).get('organizationID');
        this.datatable = this.init('#admin-roles-datatable', organizationID);
        this.initActions(organizationID);
    }
    init(el, organizationID){
        let thisClass = this;
        const datatable =  $(el).DataTable({
            searchDelay: 400,
            processing: true,
            serverSide: true,
            stateSave: false,
            info: true,
            paging: true,
            ajax: {
                url: '?do=getManagers',
                type: 'POST',
                data: {
                    organizationID: organizationID
                }
            },
            language: {
                emptyTable: "No data found"
            },
            dom:
                "<'table-responsive'tr>" +
                "<'row'" +
                "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'li>" +
                "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'p>" +
                ">",
            drawCallback: function(settings) {
                // Remove all visible popovers after datatable draw
                document.querySelectorAll('.popover.fade.show').forEach(function (el) {
                    el.remove();
                });
                // Init all popovers after datatable draw
                const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
                popoverTriggerList.map(function (popoverTriggerEl) {
                    new bootstrap.Popover(popoverTriggerEl);
                });
                // init page length select
                $('select[name=admin-roles-datatable_length]').select2({minimumResultsForSearch: -1});
            },
            columns: [
                {
                    data: 'uuid',
                    title: 'Admin',
                    sortable: true,
                    render: function (data, type, row) {
                        let avatarUrl = '/media/goodaccess/avatars/svg/Icon with face-' + row['avatarID'] + '.svg';
                        if (row['accepted']) {
                            return '<div class="d-flex align-items-center">' +
                                '       <div class="symbol symbol-40px me-3 border ga-border-primary-300 symbol-circle">' +
                                '           <div class="symbol-label bg-light-primary border border-2 border-white'+(row['isBlocked'] === 1 ? ' filter-grayscale' : '')+'">' +
                                                (row['avatarID'] ? '<img src="'+avatarUrl+'" alt="avatar">' : '<i class="fa-solid fa-user-clock fs-1"></i>') +
                                '           </div>' +
                                (row['isBlocked'] === 1 ? '<span class="symbol-badge badge badge-circle bg-danger start-85 top-85 w-15px h-15px fs-10 text-center text-white" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'fw-bold\'>'+(row['isIdentityBlocked'] ? 'Identity is disabled' : 'blocked')+'</div>">&#10005;</span>' : '') +
                                '       </div>' +
                                '       <div class="d-flex justify-content-start flex-column">' +
                                '           <div id="'+row['uuid']+'"><span class="fw-bold text-decoration-underline-ga primary text-primary mb-1 fs-6 '+ (row['edit'] && row['roleID'] !== 4 ? 'edit-manager' : '') +'" data-manager-name="'+row['name']+'">'+(row['name'] ? row['name'] : 'invited')+'</span>'+(row['meBadge'] ? '<span class="badge badge-light-danger badge-sm ms-2 align-center">Me</span>' : '')+'</div>' +
                                '           <div class="d-flex align-items-center">' +
                                '           <span class="fw-semibold d-block fs-7 ga-text-primary-800">'+row['email']+'</span>' +
                                '           </div>'+
                                '       </div>' +
                                '   </div>';
                        } else {
                            return '<div class="d-flex align-items-center">' +
                                '       <div class="symbol symbol-40px symbol-circle border ga-border-primary-300 me-3">' +
                                '           <div class="symbol-label bg-light-primary border border-2 border-white'+(row['isBlocked'] === 1 ? ' filter-grayscale' : '')+'">' +
                                (row['avatarID'] ? '<img src="'+avatarUrl+'" alt="avatar">' : '<i class="fa-solid fa-user-clock fs-1"></i>') +
                                '           </div>' +
                                (row['isBlocked'] === 1 ? '<span class="symbol-badge badge badge-circle bg-danger start-85 top-85 w-15px h-15px fs-10 text-center text-white" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'fw-bold\'>'+(row['isIdentityBlocked'] ? 'Identity is disabled' : 'blocked')+'</div>">&#10005;</span>' : '') +
                                '       </div>'+
                                '       <div class="d-flex justify-content-start flex-column" id="'+row['uuid']+'">' +
                                '            <div id="'+row['uuid']+'"><span class="fw-bold '+(row['edit'] ? 'resend-invitation ' : '')+'text-primary mb-1 fs-6"><span '+(row['edit'] ? 'class="text-decoration-underline-ga primary"' : '')+'>'+(row['edit'] ? 'resend invitation' : 'invited')+'</span></span></div>'+
                                '           <div class="d-flex align-items-center">' +
                                '           <span class="fw-semibold d-block fs-7 ga-text-primary-800" data-manager-username="'+row['email']+'">'+row['email']+'</span>' +
                                '        </div>'+
                                '       </div>' +
                                '   </div>';
                        }
                    }
                },
                {
                    data: null,
                    title: 'Identity',
                    sortable: false,
                    render: function (data, type, row) {
                        let html = '<div class="symbol-group symbol-hover flex-nowrap">';
                        for (let i = 0; i < row['identityArr'].length; i++) {
                            let avatarUrl = '/vendor/production/avatars/svg/ga.svg';
                            if (row['identityArr'][i]['icon']) {
                                avatarUrl = '/vendor/production/avatars/svg/' + row['identityArr'][i]['icon'] + '.svg';
                            }

                            html += `<div class="symbol symbol-40px symbol-circle border ga-border-primary-300">` +
                                `        <div class="symbol-label border border-2 border-white" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class='fw-bold text-center'>` + row['identityArr'][i]['name'] +(row['identityArr'][i]['categoryName'] ? `<span class='badge badge-light-danger badge-sm ms-2 align-center'>`+row['identityArr'][i]['categoryName']+`</span>` : ``) + `</div>">`+
                                '             <img alt="avatar" class="h-40px" src="' + avatarUrl + '" style="border-radius: 100%"/>' +
                                '        </div>' +
                                '     </div>';
                        }
                        return html+'</div>';
                    }
                },
                {
                    data: 'roleID',
                    title: 'Role',
                    sortable: false,
                    render: function (data, type, row) {
                       return '<span class="badge badge-light-danger me-1" data-manager-role="'+row['roleName']+'" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'text-center\'>'+row['roleDescription']+'<div>">'+row['roleName']+'</span>';
                    }
                },
                {
                    data: null,
                    title: 'Action',
                    sortable: false,
                    render: function (data, type, row) {
                        let html = '<div class="datatable-action min-w-3" id="'+row['uuid']+'">';
                        if (row['edit']) {
                                html += '<div class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-2 edit-manager" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-content="Edit">' +
                                    '           <span class="svg-icon svg-icon-3">' +
                                    '               <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                                    '                   <path opacity="0.3" d="M21.4 8.35303L19.241 10.511L13.485 4.755L15.643 2.59595C16.0248 2.21423 16.5426 1.99988 17.0825 1.99988C17.6224 1.99988 18.1402 2.21423 18.522 2.59595L21.4 5.474C21.7817 5.85581 21.9962 6.37355 21.9962 6.91345C21.9962 7.45335 21.7817 7.97122 21.4 8.35303ZM3.68699 21.932L9.88699 19.865L4.13099 14.109L2.06399 20.309C1.98815 20.5354 1.97703 20.7787 2.03189 21.0111C2.08674 21.2436 2.2054 21.4561 2.37449 21.6248C2.54359 21.7934 2.75641 21.9115 2.989 21.9658C3.22158 22.0201 3.4647 22.0084 3.69099 21.932H3.68699Z" fill="currentColor"></path>\n' +
                                    '                   <path d="M5.574 21.3L3.692 21.928C3.46591 22.0032 3.22334 22.0141 2.99144 21.9594C2.75954 21.9046 2.54744 21.7864 2.3789 21.6179C2.21036 21.4495 2.09202 21.2375 2.03711 21.0056C1.9822 20.7737 1.99289 20.5312 2.06799 20.3051L2.696 18.422L5.574 21.3ZM4.13499 14.105L9.891 19.861L19.245 10.507L13.489 4.75098L4.13499 14.105Z" fill="currentColor"></path>\n' +
                                    '               </svg>' +
                                    '           </span>' +
                                    '       </div>';

                                if(row['roleID'] !== 4){
                                    if(!row['accepted']){
                                        html += '<div class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-2 resend-invitation" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-content="Resend invitation">' +
                                            '           <span class="svg-icon svg-icon-3">' +
                                            '               <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">'+
                                            '                   <path opacity="0.3" d="M21 19H3C2.4 19 2 18.6 2 18V6C2 5.4 2.4 5 3 5H21C21.6 5 22 5.4 22 6V18C22 18.6 21.6 19 21 19Z" fill="currentColor"/>'+
                                            '                   <path d="M21 5H2.99999C2.69999 5 2.49999 5.10005 2.29999 5.30005L11.2 13.3C11.7 13.7 12.4 13.7 12.8 13.3L21.7 5.30005C21.5 5.10005 21.3 5 21 5Z" fill="currentColor"/>'+
                                            '               </svg>' +
                                            '           </span>' +
                                            '       </div>';
                                    } else if(row['isBlocked'] && !row['isIdentityBlocked']){
                                        html += '<div class="btn btn-icon btn-bg-light btn-sm me-2 btn-active-color-primary unblock-manager cursor-pointer" data-cy="unblock-manager-btn" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="Unblock">'+
                                            '           <span class="svg-icon svg-icon-3">' +
                                            '               <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">'+
                                            '                   <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor"/>'+
                                            '                   <path d="M10.4343 12.4343L8.75 10.75C8.33579 10.3358 7.66421 10.3358 7.25 10.75C6.83579 11.1642 6.83579 11.8358 7.25 12.25L10.2929 15.2929C10.6834 15.6834 11.3166 15.6834 11.7071 15.2929L17.25 9.75C17.6642 9.33579 17.6642 8.66421 17.25 8.25C16.8358 7.83579 16.1642 7.83579 15.75 8.25L11.5657 12.4343C11.2533 12.7467 10.7467 12.7467 10.4343 12.4343Z" fill="currentColor"/>'+
                                            '               </svg>' +
                                            '           </span>' +
                                            '        </div>';
                                    } else if(!row['isIdentityBlocked']) {
                                        html += '<div class="btn btn-icon btn-bg-light btn-sm me-2 btn-active-color-primary block-manager cursor-pointer" data-cy="block-manager-btn" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="Block">'+
                                            '           <span class="svg-icon svg-icon-3">' +
                                            '               <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">'+
                                            '                   <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor"/>'+
                                            '                   <rect x="7" y="15.3137" width="12" height="2" rx="1" transform="rotate(-45 7 15.3137)" fill="currentColor"/>'+
                                            '                   <rect x="8.41422" y="7" width="12" height="2" rx="1" transform="rotate(45 8.41422 7)" fill="currentColor"/>'+
                                            '               </svg>' +
                                            '           </span>' +
                                            '        </div>';
                                    }
                                } else {
                                    html += '<div class="btn btn-icon btn-bg-light btn-sm me-2 cursor-not-allowed" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-content="Partner`s customer cannot be edited.">'+
                                        '           <span class="svg-icon svg-icon-3">' +
                                        '               <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">'+
                                        '                   <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor"/>'+
                                        '                   <rect x="7" y="15.3137" width="12" height="2" rx="1" transform="rotate(-45 7 15.3137)" fill="currentColor"/>'+
                                        '                   <rect x="8.41422" y="7" width="12" height="2" rx="1" transform="rotate(45 8.41422 7)" fill="currentColor"/>'+
                                        '               </svg>' +
                                        '           </span>' +
                                        '        </div>';
                                }

                            html += '<div class="btn btn-icon btn-bg-light btn-sm btn-active-color-primary delete-manager cursor-pointer" data-excluded-from-ip-restriction="'+row['excludedFromIpRestrictions']+'" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="Delete">'+
                                '                   <span class="svg-icon svg-icon-3">' +
                                '                       <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                                '                           <path d="M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z" fill="currentColor"></path>' +
                                '                           <path opacity="0.5" d="M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z" fill="currentColor"></path>' +
                                '                           <path opacity="0.5" d="M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z" fill="currentColor"></path>' +
                                '                       </svg>' +
                                '                   </span>' +
                                '               </div>';
                        }
                        return html+'</div>';
                    }
                }
            ]
        }).on('init.dt', function () {
            if(datatable.page.info().recordsTotal === 0){
                $('#admin-roles-datatable_wrapper').hide();
                $('#admin-roles-datatable_no-results').addClass('d-flex flex-center flex-column').removeClass('d-none');
            }
        });
        // Init and add delay to datatable search
        new DatatableSearchDelay(datatable, '[data-kt-docs-table-filter=search]');
        return datatable;
    }
    generateIdpBadges(idp = null) {
        let html = '';
        if(idp == null || idp.length === 0){
            return `<span class="symbol-badge idp-badge badge badge-circle start-85 top-85 w-15px h-15px pb-0"
                           data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true"
                           data-bs-content="<div>Identity: GoodAccess</div>">
                        <div class="img" style="background-image: url('/media/goodaccess/logo/goodaccess-mobile.svg')"></div>      
                     </span>`
        }

            html += `<span class="symbol-badge idp-badge badge badge-circle start-85 top-85 w-15px h-15px pb-0"
                           data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true"
                           data-bs-content="<div>Identity: ${idp['name']}</div>">
                        <div class="img" style="background-image: url('/vendor/production/avatars/svg/${idp['icon']}.svg')"></div>      
                     </span>`;
        return html;
    }
    initActions(organizationID){
        const thisClass = this;

        $(document).on('click', '.unblock-manager', function(e) {
            let managerID = $(this).parent()[0].id;
            let managerName = '';
            managerName = $(this).closest('tr').find('span[data-manager-name]').attr('data-manager-name');
            if(managerName === undefined){
                managerName = $(this).closest('tr').find('span[data-manager-username]').attr('data-manager-username');
            }
            let managerRole = $(this).closest('tr').find('span[data-manager-role]').attr('data-manager-role');
            Swal.fire({
                html: `<span class="text-center text-primary">`+(managerRole !== undefined ? managerRole+` ` : `Admin `)+` `+(managerName !== undefined && managerName !== 'null' ? `<b>`+managerName+`</b> ` : ``)+`is going to be unblocked!</span>`,
                icon: "warning",
                iconColor: "#FF5206",
                buttonsStyling: false,
                reverseButtons: true,
                showCancelButton: true,
                confirmButtonText: "Yes, unblock!",
                customClass: {
                    confirmButton: "btn btn-danger mt-0",
                    cancelButton: 'btn btn-light-primary mt-0',
                },
                showLoaderOnConfirm: true,
                returnFocus: false,
                preConfirm: () => {
                    return fetch('/admin-roles?do=unblockManager&organizationID='+organizationID+'&managerID='+managerID)
                        .then(response => {
                            if (!response.ok) {
                                throw new Error(response.statusText)
                            }
                            return response.json();
                        }).catch(error => {
                            Swal.showValidationMessage(`Request failed: ${error}`)
                        });
                },
                allowOutsideClick: () => !Swal.isLoading(),
                allowEscapeKey: () => !Swal.isLoading()
            }).then((result) => {
                if (result.isConfirmed) {
                    if(result.value === 'unblocked'){
                        toastr.success('Admin has been successfully unblocked!');
                        thisClass.datatable.ajax.reload(null, false);
                    }
                }
            });
        });
        $(document).on('click', '.block-manager', function(e) {
            let managerID = $(this).parent()[0].id;
            let managerName = '';
            managerName = $(this).closest('tr').find('span[data-manager-name]').attr('data-manager-name');
            if(managerName === undefined){
                managerName = $(this).closest('tr').find('span[data-manager-username]').attr('data-manager-username');
            }
            let managerRole = $(this).closest('tr').find('span[data-manager-role]').attr('data-manager-role');
            Swal.fire({
                html: `<span class="text-center text-primary">`+(managerRole !== undefined ? managerRole+` ` : `Admin `)+` `+(managerName !== undefined && managerName !== 'null' ? `<b>`+managerName+`</b> ` : ``)+`is going to be blocked!</span>`,
                icon: "warning",
                iconColor: "#FF5206",
                buttonsStyling: false,
                reverseButtons: true,
                showCancelButton: true,
                confirmButtonText: "Yes, block!",
                customClass: {
                    confirmButton: "btn btn-danger mt-0",
                    cancelButton: 'btn btn-light-primary mt-0',
                },
                showLoaderOnConfirm: true,
                returnFocus: false,
                preConfirm: () => {
                    return fetch('/admin-roles?do=blockManager&organizationID='+organizationID+'&managerID='+managerID)
                        .then(response => {
                            if (!response.ok) {
                                throw new Error(response.statusText)
                            }
                            return response.json();
                        }).catch(error => {
                            Swal.showValidationMessage(`Request failed: ${error}`)
                        });
                },
                allowOutsideClick: () => !Swal.isLoading(),
                allowEscapeKey: () => !Swal.isLoading()
            }).then((result) => {
                if (result.isConfirmed) {
                    if(result.value === 'blocked'){
                        toastr.success('Admin has been successfully blocked!');
                        thisClass.datatable.ajax.reload(null, false);
                    }
                }
            });
        });
        $(document).on('click','#admin-roles-datatable .delete-manager',function(e){
            let managerID = $(this).parent()[0].id;
            let managerName = '';
            managerName = $(this).closest('tr').find('span[data-manager-name]').attr('data-manager-name');
            if(managerName === undefined){
                managerName = $(this).closest('tr').find('span[data-manager-username]').attr('data-manager-username');
            }
            let managerRole = $(this).closest('tr').find('span[data-manager-role]').attr('data-manager-role');
            let html = `
                <div class="text-center text-primary">You are about to revoke `+(managerName !== undefined ? `<b>`+managerName+`</b>` : `this user's`)+` privileges!</div>
                <div class="text-center text-primary mt-5"><b>Please note:</b> Deleting this `+(managerRole !== undefined ? managerRole : `Admin`)+` will also delete all records (logs) related to their activities.</div>
                <div class="form-check mt-5">
                    <input class="form-check-input float-none corsor-pointer" name="agreeSwalCheckbox" type="checkbox" value="" id="agreeSwalCheckbox" />
                    <label class="form-check-label text-primary corsor-pointer" for="agreeSwalCheckbox">
                        I agree
                    </label>
                </div>`;

            Swal.fire({
                html: html,
                icon: "warning",
                iconColor: "#FF5206",
                buttonsStyling: false,
                reverseButtons: true,
                showCancelButton: true,
                confirmButtonText: "Yes, revoke privileges!",
                customClass: {
                    confirmButton: "btn btn-danger mt-0",
                    cancelButton: 'btn btn-light-primary mt-0',
                },
                showLoaderOnConfirm: true,
                returnFocus: false,
                preConfirm: () => {
                    let agreeSwalCheckbox = document.querySelector('input[name="agreeSwalCheckbox"]');
                    if(agreeSwalCheckbox && !agreeSwalCheckbox.checked){
                        Swal.showValidationMessage(`You need to agree`);
                        return;
                    }

                    return fetch('/admin-roles?do=removeManager&organizationID='+organizationID+'&managerID='+managerID)
                        .then(response => {
                            if (!response.ok) {
                                throw new Error(response.statusText)
                            }
                            return response.json();
                        }).catch(error => {
                            Swal.showValidationMessage(`Request failed: ${error}`)
                        });
                },
                allowOutsideClick: () => !Swal.isLoading(),
                allowEscapeKey: () => !Swal.isLoading()
            }).then((result) => {
                if (result.isConfirmed) {
                    if(result.value === 'deleted') {
                        toastr.success('Admin has been deleted.');
                        let editManagerModal = document.getElementById('edit_manager_modal');
                        if(editManagerModal){
                            bootstrap.Modal.getOrCreateInstance(editManagerModal).hide();
                        }
                        thisClass.datatable.ajax.reload(null, false);
                    }
                }
            });
        });
        $(document).on('click', '.resend-invitation', function(e) {
            let managerID = $(this).parent()[0].id;
            let managerName = $(this).closest('tr').find('span[data-manager-username]').attr('data-manager-username');
            Swal.fire({
                html: `<span class="text-center text-primary">Resend invitation to `+(managerName !== undefined ? `<b>`+managerName+`</b>` : `this User`)+`?</span>`,
                icon: "question",
                iconColor: "#FF5206",
                buttonsStyling: false,
                reverseButtons: true,
                showCancelButton: true,
                confirmButtonText: "Yes, send it!",
                customClass: {
                    confirmButton: "btn btn-danger mt-0",
                    cancelButton: 'btn btn-light-primary mt-0',
                },
                showLoaderOnConfirm: true,
                returnFocus: false,
                preConfirm: () => {
                    return fetch('/admin-roles?do=resendInvitation&organizationID='+organizationID+'&managerID='+managerID)
                        .then(response => {
                            if (!response.ok) {
                                throw new Error(response.statusText)
                            }
                            return response.json();
                        }).catch(error => {
                            Swal.showValidationMessage(`Request failed: ${error}`)
                        });
                },
                allowOutsideClick: () => !Swal.isLoading(),
                allowEscapeKey: () => !Swal.isLoading()
            }).then((result) => {
                if (result.isConfirmed) {
                    if(result.value) {
                        toastr.success('Invitation has been sent.');
                    }
                }
            });
        });
    }
}
window.AdminRolesDatatable = AdminRolesDatatable;